var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M15.5 7.844h-2c-4.97 0-9 3.966-9 8.86V33.78a3.375 3.375 0 0 0 3.375 3.375H24.5m-9-29.312h16c.338 0 .672.018 1 .054 4.5.49 8 4.245 8 8.805V33.78a3.375 3.375 0 0 1-3.375 3.375H24.5m-9-29.312c4.97 0 9 3.966 9 8.86v20.452M14.093 23.11v7.193m0-7.193h4.71m-4.71 0H9.5m9.302-3.698H9.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailus);
export default __webpack_public_path__ + "static/media/mailus.09bb78d6b3481abc1e1a0aa6592f7fea.svg";
export { ForwardRef as ReactComponent };